import React, { useContext, useState, useEffect, useRef } from 'react';
import whitelogo from '../assets/img/logo.png';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import LockIcon from '@mui/icons-material/Lock';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import MailIcon from '@mui/icons-material/Mail';
import athleticimg from '../assets/img/authentic_logo-white.png';
import {
  Navigate,
  useNavigate,
  Link
} from "react-router-dom";
import { useDispatch } from "react-redux";
import { AppContext } from '../context';

import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import secureLocalStorage from "react-secure-storage";
  // modal code start

  import { styled } from '@mui/material/styles';
  import Dialog from '@mui/material/Dialog';
  import DialogTitle from '@mui/material/DialogTitle';
  
  import IconButton from '@mui/material/IconButton';
  import CloseIcon from "@mui/icons-material/Close";
  
  import DialogContent from '@mui/material/DialogContent';
  import Typography from '@mui/material/Typography';
  // modal code end
 // reset psd code modal end
 const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}
function StaffLogin() {

  React.useEffect(() => {
    if (document.body.classList.contains('adminbody_bg')) {
      document.body.classList.remove('body');

    }
    document.body.classList.add('adminbody_bg');

  });


  const [user, setUser] = useState({ empid: '', email: '', ipuser: '', emp_name: '', otp_status: '', create_pass: '', confirm_pass: '' });
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [loader, setLoader] = useState(false);
  const [userData, setuserData] = useState('');
  const [loaderemp, setLoaderemp] = useState(false);

  const [password, setPassword] = useState(true);
  const { storage } = useContext(AppContext);
  const { dispatchStorageEvent } = useContext(AppContext);
  const [erroruserid, setErrorUserid] = useState(false);
  const [errorpassword, setErrorPassword] = useState(false);
  const [erroremail, setErrorEmail] = useState(false);
  const [loginval, setloginval] = useState(0);
  const timersRef = useRef([]); // Ref to store timers for each character
  const [displayPassword, setDisplayPassword] = useState('');
  const [displayPasswordCon, setDisplayPasswordCon] = useState('');
  const [displayEmpid, setDisplayEmpid] = useState('');

  const [errorcreatepassword, setErrorCreatePassword] = useState(false);
  const [errorconfirmpassword, setErrorConfirmPassword] = useState(false);
  const Axios = axios.create({
    baseURL: storage[0].backEndUrl
    // baseURL: process.env.REACT_APP_ENV_URL
  });
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [passwordparent, setPasswordparent] = useState(true);
  React.useEffect(() => {
    return cleanupTimers; // Cleanup on component unmount
  }, []);
  const cleanupTimers = () => {
    timersRef.current.forEach(timer => clearTimeout(timer));
    timersRef.current = [];
  };
  const [view, setView] = React.useState(false);
  const handleClick = () => {
    setPasswordparent(false);
    setView(true)
  }
  const handlehideClick = () => {
    setPasswordparent(true);
    setView(false)
  }
  const handleKeypress = (e) => {

    //it triggers by pressing the enter key
    if (e.which === 13) {
      handleSubmit();
      e.preventDefault();
    }
  };
  const changeUserData = (e) => {
    setErrorUserid(false);
    setErrorPassword(false);
    setErrorEmail(false);
    setErrorCreatePassword(false);
    setErrorConfirmPassword(false);
    setErrorMsg('');
    var user_temp = { ...user };

    if (e.target.name == 'empid') {
      let curpassfin = '';
      let lastsr = e.target.value;
      let str = e.target.value;
      if (lastsr.length == 1 && lastsr.slice(-1) != '*') {
        user_temp.empid = e.target.value;
        //  alert(user_temp.empid);
      } else {

        if (lastsr.slice(-1).includes("*")) {

          // alert(user_temp.empid);
          user_temp.empid = user_temp.empid.substring(0, user_temp.empid.length - 1);

        } else {
          //  alert(user_temp.empid);
          if (user_temp.empid != '') {
            user_temp.empid = user_temp.empid + lastsr.slice(-1);
          } else {
            user_temp.empid = e.target.value;
            //  
          }
        }
        if (e.target.value == '') {
          user_temp.empid = '';
        }

      }

      setUser(user_temp);
      let curpass = '';
      for (let i = 0; i < (str.length - 1); i++) {
        curpass = curpass + '*';
      }

      for (let i = 0; i < (str.length); i++) {
        curpassfin = curpassfin + '*';
      }

      setDisplayEmpid(curpass + lastsr.slice(-1));
      if (e.target.value != '') {

        const timer = setTimeout(() => {
          setDisplayEmpid(prev => prev.slice(0, -1) + "*");
        }, 2000);
        // Store the timer in the ref array
        timersRef.current.push(timer);

      }





    }

    if (e.target.name == 'emp_name') {
      user_temp.emp_name = e.target.value;
      setUser(user_temp);
    }
    if (e.target.name == 'email') {
      user_temp.email = e.target.value;
      setUser(user_temp);
    }
    if (e.target.name == 'create_pass') {
      let curpassfin = '';
      let lastsr = e.target.value;
      let str = e.target.value;
      if (lastsr.length == 1 && lastsr.slice(-1) != '*') {
        user_temp.create_pass = e.target.value;
        //  alert(user_temp.create_pass);
      } else {

        if (lastsr.slice(-1).includes("*")) {

          // alert(user_temp.create_pass);
          user_temp.create_pass = user_temp.create_pass.substring(0, user_temp.create_pass.length - 1);

        } else {
          //  alert(user_temp.create_pass);
          if (user_temp.create_pass != '') {
            user_temp.create_pass = user_temp.create_pass + lastsr.slice(-1);
          } else {
            user_temp.create_pass = e.target.value;
            //  
          }
        }
        if (e.target.value == '') {
          user_temp.create_pass = '';
        }

      }

      setUser(user_temp);
      let curpass = '';
      for (let i = 0; i < (str.length - 1); i++) {
        curpass = curpass + '*';
      }

      for (let i = 0; i < (str.length); i++) {
        curpassfin = curpassfin + '*';
      }

      setDisplayPassword(curpass + lastsr.slice(-1));
      if (e.target.value != '') {

        const timer = setTimeout(() => {
          setDisplayPassword(prev => prev.slice(0, -1) + "*");
        }, 2000);
        // Store the timer in the ref array
        timersRef.current.push(timer);

      }





    }

    if (e.target.name == 'confirm_pass') {
      let curpassfin = '';
      let lastsr = e.target.value;
      let str = e.target.value;
      if (lastsr.length == 1 && lastsr.slice(-1) != '*') {
        user_temp.confirm_pass = e.target.value;
        //  alert(user_temp.confirm_pass);
      } else {

        if (lastsr.slice(-1).includes("*")) {

          // alert(user_temp.confirm_pass);
          user_temp.confirm_pass = user_temp.confirm_pass.substring(0, user_temp.confirm_pass.length - 1);

        } else {
          //  alert(user_temp.confirm_pass);
          if (user_temp.confirm_pass != '') {
            user_temp.confirm_pass = user_temp.confirm_pass + lastsr.slice(-1);
          } else {
            user_temp.confirm_pass = e.target.value;
            //  
          }
        }
        if (e.target.value == '') {
          user_temp.confirm_pass = '';
        }

      }

      setUser(user_temp);
      let curpass = '';
      for (let i = 0; i < (str.length - 1); i++) {
        curpass = curpass + '*';
      }

      for (let i = 0; i < (str.length); i++) {
        curpassfin = curpassfin + '*';
      }

      setDisplayPasswordCon(curpass + lastsr.slice(-1));
      if (e.target.value != '') {

        const timer = setTimeout(() => {
          setDisplayPasswordCon(prev => prev.slice(0, -1) + "*");
        }, 2000);
        // Store the timer in the ref array
        timersRef.current.push(timer);

      }





    }




  }
  const handleSubmitnew = (event) => {
    if (user.empid != '' && user.emp_name != '') {
      setLoaderemp(true);
      setErrorMsg('');

      Axios.post(`/staff_varify`, { empid: user.empid, emp_name: user.emp_name })
        .then(res => {
          if (res.data.status == true) {
            var user_temp = { ...user };
            user_temp.email = res.data.data.email;
            user_temp.otp_status = res.data.data.otp_status;
            setUser(user_temp);
            setLoaderemp(false);
          } else {
            var user_temp = { ...user };
            user_temp.email = '';
            user_temp.otp_status = '';
            setUser(user_temp);
            setErrorMsg(res.data.data);
            setLoaderemp(false);
          }
        });
    }
  }

  const handleSubmitnewcl = (event) => {
    setErrorMsg('');
    setErrorUserid(false);
    setErrorPassword(false);
    setErrorEmail(false);
  }
  const handleSubmit = (event) => {

    setErrorMsg('');
    setSuccessMsg('');
    setErrorUserid(false);
    setErrorPassword(false);

    setErrorCreatePassword(false);
    setErrorConfirmPassword(false);
    if (user.emp_name == '') { setErrorPassword(true); return false; }
    if (user.empid == '') { setErrorUserid(true); return false; }
    if (user.email == '') { setErrorEmail(true); return false; }
    if (user.otp_status == 'pending') {
      if (user.create_pass == '') { setErrorCreatePassword(true); return false; }
      if (user.confirm_pass == '') { setErrorConfirmPassword(true); return false; }
    }


    if (user.otp_status == 'approved') {
      if (user.create_pass == '') { setErrorCreatePassword(true); return false; }
      setLoader(true);
      Axios.post(`/staff_login`, { empid: user.empid, emp_name: user.emp_name, email: user.email, password: user.create_pass })
        .then(res => {
          console.log(res.data);

          if (res.data.status == true) {
            console.log(res.data.data);
            storage[0].userdata = res.data.data;
            // localStorage.setItem("nursedata", JSON.stringify(res.data.data));
            // localStorage.setItem('nurseid', user.empid);
           

            dispatchStorageEvent(storage);
            setSuccessMsg('Staff Login Successfully!');
            
               secureLocalStorage.setItem("nursedata", JSON.stringify(res.data.data));
            secureLocalStorage.setItem("nurseid", user.empid);

            

            setTimeout(function () {

              setloginval(1);
              if (res.data.data.type == 'N') {
                navigate('/application');
              } else {
                navigate('/applicationstatus');
              }


              setLoader(false);
            }, 1000);
          }
          else {
            setloginval(0);
            setErrorMsg(res.data.data);
            setLoader(false);
          }
        });
    }

      
    if(user.otp_status=='pending'){
      if (user.create_pass == '') { setErrorCreatePassword(true); return false; }
      if (user.confirm_pass == '') { setErrorConfirmPassword(true); return false; }
       if (user.confirm_pass != user.create_pass) { setErrorMsg('Create and Confirm Password must be Same'); return false; }
      setLoader(true);
      Axios.post(`/staff_otp_check`, { empid: user.empid, emp_name: user.emp_name, email: user.email , password:user.create_pass})
        .then(res => {
          console.log(res.data);
  
          if (res.data.status == true) {
            console.log(res.data.data);
            storage[0].userdata = res.data.data;
            // localStorage.setItem("nursedata", JSON.stringify(res.data.data));
            // localStorage.setItem('nurseid', user.empid);
            secureLocalStorage.setItem("nursedata", JSON.stringify(res.data.data));
            secureLocalStorage.setItem("nurseid", user.empid);
  
  
            dispatchStorageEvent(storage);
            setSuccessMsg('Your Password is saved successfully');
  
  
  
            setTimeout(function () {
  
              //setloginval(1);
              if (res.data.data.type == 'N') {
                navigate('/application');
              } else {
                navigate('/applicationstatus');
              }
  
  
              setLoader(false);
            }, 1000);
          }
          else {
            setloginval(0);
            setErrorMsg(res.data.data);
            setLoader(false);
          }
        });
    }


  }

  function handleKeyAccountPress(event) {
    const charCode = event.which || event.keyCode;

    if (charCode != 43 && charCode > 31 && (charCode < 48 || charCode > 57)) {
      // The pressed key is not a number
      setErrorMsg('Only Numbers are allowed');
      event.preventDefault();
    }
  }

  // if (loginval == 1) {
  //   return <Navigate to='/application' />;
  // }

  const [forgotmail, setForgotmail] = useState('');
  const [loginvalnew, setloginvalnew] = useState(0);
const [successMsgforgot, setSuccessMsgforgot] = useState('');
 const [errorMsgforgot, setErrorMsgforgot] = useState('');
 const [loaderforgot, setLoaderforgot] = useState(false);
   const [openForgot, setOpenForgot] = React.useState(false);
   const handleOpenForgot = () => 
   {setForgotmail('');
    setSuccessMsgforgot('');
   setErrorMsgforgot('');
       setOpenForgot(true);
       
   }
   const handleCloseForgot = () =>{

      setOpenForgot(false);
   } 
     const changeUserDataFor = (e) => {
   setForgotmail(e.target.value);
 }

 const handleKeypressfor = e => {
     
  //it triggers by pressing the enter key
  if (e.which === 13) {
       e.preventDefault();
    handleSubmitfor();

  }
};


const handleSubmitfor = (event) => {

  setSuccessMsgforgot('');
  setErrorMsgforgot('');
  
  if (forgotmail == '') { setErrorMsgforgot('Please Enter Email'); return false; }
  
  setLoaderforgot(true);
 
  Axios.post(`/forgot_passowrd_staff`, { email: forgotmail})
    .then(res => {
      console.log(res.data);

      if (res.data.status == true) {
        console.log(res.data.data);
       setForgotmail('');
        setSuccessMsgforgot(res.data.data);

                  setLoaderforgot(false);
                
                  

setTimeout(function () {
            setSuccessMsgforgot('');
            setOpenForgot(false);
 
            }, 3000);



              }
              else {
                  
                  setErrorMsgforgot(res.data.data);
                  setLoaderforgot(false);
              }
          });
  }
  return (

    <>
      <div className='login-sec staff-login-sec'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='login-header'>
              <div className='col-md-12'>
                <img src={whitelogo} alt='logo' />
              </div>
            </div>
          </div>

          <div className='row'>
            <div className='col-md-12'>
              <div className='login-content-sec'>
                <h2>Staff Login</h2>
              </div>
            </div>
          </div>

          <div className='login-sec-new login-sec-newss'>
            <div className='row'>

              <div className="col-md-12 padding-left">
                <div className='login-sec-page login-sec-pagess'>

                  <div className='login-img'>
                    <img src={athleticimg} />
                  </div>


                  <div className='login-secs login-secsss login-secssss'>
                    <Box
                      component="form"
                      sx={{
                        '& > :not(style)': { m: 1, width: '90%', margin: '0 auto' },
                      }}
                      noValidate
                      autoComplete="off"
                    >

                      <TextField id="standard-basic" label="EMP First Name"

                        value={user.emp_name} onChange={changeUserData}
                        onClick={handleSubmitnewcl}
                        onBlur={handleSubmitnew}
                        name="emp_name"
                        error={errorpassword}
                        helperText={` ${errorpassword == true ? 'Please enter First Name!' : ''}`} placeholder="Enter First Name"


                        variant="outlined"


                      />
                      <span className='login-icon lgn-icn'><PersonIcon /></span>
                    </Box>
                  </div>

                  <div className={`login-secs login-secsss login-secssss ${displayEmpid!='' && 'new-pass-ass'  }`} >
                    <Box
                      component="form"
                      sx={{
                        '& > :not(style)': { m: 1, width: '90%', margin: '0 auto' },
                      }}
                      noValidate
                      autoComplete="off"
                    >

                      <TextField id="standard-basic" label="EMP ID" variant="outlined"
                        type={'text'}
                        name="empid"
                        value={displayEmpid} onChange={changeUserData}
                        error={erroruserid}
                        onClick={handleSubmitnewcl}
                        onBlur={handleSubmitnew}
                        helperText={` ${erroruserid == true ? 'Please enter Employee Id!' : ''}`} placeholder="Enter EMP ID"

                        onKeyPress={(e) => { handleKeypress(e); handleKeyAccountPress(e) }}
                      />
                      <span className='login-icon lgn-icn'><LockIcon /></span>
                      {/* <div className='eye-iconsss'>
                                                <VisibilityIcon onClick={handlehideClick} style={{display: view ? 'block' : 'none'}}  />
                                                <VisibilityOffIcon onClick={handleClick}  style={{display: view ? 'none' : 'block'}}   />
                                            </div> */}

                      <div class="loader-login new-lder-lgn">
                        {
                          loaderemp != '' ?
                            <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "#ffffff" }} />
                            : ''
                        }
                      </div>
                    </Box>
                  </div>


                  <div className='login-secs login-secsss login-secssss '>
                    <Box
                      component="form"
                      sx={{
                        '& > :not(style)': { m: 1, width: '90%', margin: '0 auto' },
                      }}
                      noValidate
                      autoComplete="off"
                    >
                      <TextField id="standard-basic" label="EMP Email" variant="outlined"
                        name="email"
                        helperText={` ${erroremail == true ? 'Please enter EMP Email!' : ''}`} placeholder="Enter EMP ID"

                        value={user.email} onKeyPress={handleKeypress}
                      />
                      <span className='login-icon lgn-icn'><EmailIcon /></span>
                    </Box>
                  </div>

                  {user.otp_status == 'pending' &&
                    <>
 
                      <div className={`login-secs login-secsss login-secssss ${displayPassword!='' && 'new-pass-ass'  }`}>
                        <Box
                          component="form"
                          sx={{
                            '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                          }}
                          noValidate
                          autoComplete="off"
                        >

                          <TextField id="standard-basic" label="Create Password" variant="outlined"
                            type={'text'}
                            onKeyPress={handleKeypress}
                            name="create_pass"
                            value={displayPassword} onChange={changeUserData}

                            error={errorcreatepassword} placeholder=''

                            helperText={` ${errorcreatepassword == true ? 'Please enter Create Password!' : ''}`}  />
                          <span className='login-icon lgn-icn'><LockIcon /></span>


                        </Box>
                      </div>
                      

                      <div className={`login-secs login-secsss login-secssss ${displayPasswordCon!='' && 'new-pass-ass'  }`}>
                        <Box
                          component="form"
                          sx={{
                            '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                          }}
                          noValidate
                          autoComplete="off"
                        >

                          <TextField id="standard-basic" label="Confirm Password" variant="outlined"
                            type={'text'}
                            onKeyPress={handleKeypress}
                            name="confirm_pass"
                            value={displayPasswordCon} onChange={changeUserData}

                            error={errorconfirmpassword} placeholder=''

                            helperText={` ${errorconfirmpassword == true ? 'Please enter Confirm Password!' : ''}`}  />
                          <span className='login-icon lgn-icn'><LockIcon /></span>

                        </Box>
                      </div>

                    </>
                  }



                  {user.otp_status == 'approved' &&
                    <>

                      <div className={`login-secs login-secsss login-secssss ${displayPassword!='' && 'new-pass-ass'  }`}>
                        <Box
                          component="form"
                          sx={{
                            '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                          }}
                          noValidate
                          autoComplete="off"
                        >

                          <TextField id="standard-basic" label=" Password" variant="outlined"
                            type={'text'}
                            onKeyPress={handleKeypress}
                            name="create_pass"
                            value={displayPassword} onChange={changeUserData}

                            error={errorcreatepassword} placeholder=''

                            helperText={` ${errorcreatepassword == true ? 'Please enter  Password!' : ''}`}  />
                          <span className='login-icon lgn-icn'><LockIcon /></span>


                        </Box>
                      </div>




                    </>
                  }
                  <div className='login-submit'>

                    <button
                      className='btn btn-login btn-login-sumt btn-nsd-sbmit'
                      onClick={handleSubmit} >SUBMIT
                      {
                        loader != '' ?
                          <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "#ffffff", position: 'absolute', marginTop: '3px' }} />
                          : ''
                      }
                    </button>
                    <p className='login-sec-nse' onClick={handleOpenForgot}>Forgot Password ?</p> 
                    {
                      loader != '' ? <div className="success-msg success-login success-new-msg new-stff-mg">
                        <p className="success-msg success-login">Please wait while we get you access to the system</p>

                      </div> : <div className="success-msg success-login success-new-msg new-stff-mg">
                        <p className="success-msg success-login" style={{ visibility: 'hidden' }} >Please wait while we fetch your data</p>
                      </div>
                    }




                    {
                      errorMsg != '' ? <div className="error-msg error-login" >
                        <p className="error-msg error-login">{errorMsg}</p>
                      </div> : <div className="error-msg error-login" style={{ visibility: 'hidden' }} >
                        <p className="error-msg error-login">Wrong credentials!</p>
                      </div>
                    }
                    {
                      successMsg != '' ? <div className="success-msg success-login">
                        <p className="success-msg success-login">{successMsg}</p>
                      </div> : ''
                    }

                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>


  {/* modal for forgot password start */}
  <BootstrapDialog
          onClose={handleCloseForgot}
          aria-labelledby="customized-dialog-title"
          open={openForgot} className="route-view copy-view logout-view login-modal">
          <BootstrapDialogTitle className="close-routeview" id="customized-dialog-title" onClose={handleCloseForgot}>
            {/* <h2 style={{padding:'5px 0px 0px 0px',color:'#ffffff'}}>Logout</h2> */}
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <Typography gutterBottom>
              <div className='copy-sec-modal logout-sec-modal add-club-sec' style={{ paddingTop: '0px' }}>
                {/* <h2 style={{color:'#57585A',paddingTop:'0px'}}>Logout</h2> */}
              
                <h2>Forgot Password</h2>
                 <p className="forgot-psd-secnew " >Use your  email id to get a password reset link</p>


                <div className='login-mdl-sec'>

                <div className='login-secs modl-login'>
                    <Box
                        component="form"
                        sx={{
                            '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                        }}
                        noValidate
                        autoComplete="off"
                        >

                        <TextField id="standard-basic" label="Email Id" variant="outlined"
                               value={forgotmail} onChange={changeUserDataFor} onKeyPress={handleKeypressfor}
                  name="forem" />
                    <span className='login-icon mod-login-icn'><MailIcon /></span>
                   
                   
                    </Box>
                </div>
                <div className='login-submit mdl-lgn-sbm sub-login-sec'>
                    <button className='btn btn-login btn-login-sumt btn-mdl-smt' onClick={handleSubmitfor}>SUBMIT

                      {
                  loaderforgot != '' ?
                    <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "#ffffff", position: 'absolute', marginTop: '3px' }} />
                    : ''

                }</button>
                  

         {
                                                                    loaderforgot != '' ? <div className="success-msgfor success-new-msgfor new-sucs-main">
                                                                        <p className="success-msgfor new-sucss">Please wait while we get you access to the system</p>

                                                                    </div> : 
                                                                    <div className="success-msgfor success-new-msgfor new-sucs-main">
                                                                    <p className="success-msgfor new-sucss" style={{ visibility: 'hidden' }}  >Password Reset Link sent to your  email address, remember to check spam box if it isn't there in your inbox</p>
                                                                    </div>
                                                                }
                    {
              successMsgforgot != '' ? <div className="success-msgfor success-new-msgfor new-sucs-main">
                                                                        <p className="success-msgfor new-sucss">Password Reset Link sent to your  email address, remember to check spam box if it isn't there in your inbox</p>

                                                                    </div> : ''
            }


            {
              errorMsgforgot != '' ? <div className="error-msg error-login erron-neww" >
                <p className="error-msg error-login erron-neww-dd">{errorMsgforgot}</p>
              </div> : <div className="error-msg error-login erron-neww" style={{ visibility: 'hidden' }} >
                <p className="error-msg error-login erron-neww-dd">Wrong credentials!</p>
              </div>
            }
                </div>

                </div>

            
              </div>
            
             
            </Typography>
          </DialogContent>
        </BootstrapDialog>
        {/* modal for forgot password end */}
    </>
  )
}
export default StaffLogin;